import React from "react";
import AdminLayout from "../../LayoutWrapper/AdminLayout";
import { useTranslation } from "react-i18next";
import Vaccinated from "../../Images/Safety/syringe.jpg";
import Mask from "../../Images/Safety/face-mask.jpg";
import Scanning from "../../Images/Safety/scanning.jpg";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import DirectionsCarFilledOutlinedIcon from "@mui/icons-material/DirectionsCarFilledOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import "../../CSS/Safety/modern.css";

const COVID_MEASURES = [
  { image: Vaccinated, titleKey: "covid_point1", paraKey: "covid_point1_para" },
  { image: Scanning, titleKey: "covid_point2", paraKey: "covid_point2_para" },
  { image: Mask, titleKey: "covid_point3", paraKey: "covid_point3_para" },
];

const Safety = () => {
  const { t } = useTranslation();

  return (
    <AdminLayout>
      <div className="safety-page">
        <section className="safety-hero">
          <div className="safety-hero__inner">
            <div className="safety-hero__content">
              <span className="safety-hero__badge">
                <ShieldOutlinedIcon sx={{ fontSize: 18 }} />
                Your safety matters
              </span>
              <h1 className="safety-hero__title">{t("page_title_safety")}</h1>
              <p className="safety-hero__text">{t("safety_banner_para")}</p>
              <div className="safety-hero__highlights">
                <span className="safety-hero__highlight">
                  <VerifiedUserOutlinedIcon fontSize="small" />
                  Vetted drivers
                </span>
                <span className="safety-hero__highlight">
                  <DirectionsCarFilledOutlinedIcon fontSize="small" />
                  Vehicle audits
                </span>
                <span className="safety-hero__highlight">
                  <ShieldOutlinedIcon fontSize="small" />
                  COVID protocols
                </span>
              </div>
            </div>
            <div
              className="safety-hero__image"
              role="img"
              aria-label="Safety with Comfort Trip"
            />
          </div>
        </section>

        <section className="safety-covid">
          <div className="safety-covid__inner">
            <header className="safety-covid__header">
              <p className="safety-covid__label">Health & hygiene</p>
              <h2 className="safety-covid__title">{t("safety_section_title1")}</h2>
            </header>
            <div className="safety-covid__grid">
              {COVID_MEASURES.map((measure) => (
                <article key={measure.titleKey} className="safety-covid-card">
                  <div className="safety-covid-card__img-wrap">
                    <img src={measure.image} alt="" />
                  </div>
                  <h3 className="safety-covid-card__title">{t(measure.titleKey)}</h3>
                  <p className="safety-covid-card__text">{t(measure.paraKey)}</p>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="safety-secure">
          <div className="safety-secure__inner">
            <div className="safety-secure__icon">
              <LockOutlinedIcon />
            </div>
            <h2 className="safety-secure__title">Secure payments & peace of mind</h2>
            <p className="safety-secure__text">{t("safety_section_para2")}</p>
          </div>
        </section>
      </div>
    </AdminLayout>
  );
};

export default Safety;
